import { Col, Container, Row, Form, Button } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { validateService} from "../service/validation.service";
import { apiService} from "../service/api.service";
import Loader from "../common/Loader";
import swal from "sweetalert";
import {baseUrl} from "../config/config"
const Login = () => {
  let history = useNavigate();
  function CreateProfile() {
    window.location.href = "/create-profile"
    // history("/create-profile");
  }
  const [loader,setLoader]=useState(false)
  const [showPass,setshowPass]=useState(false)
  const [loginFields, setloginFields] = useState({
    email: "",
    password: "",
    role:"cultivator"
   });
   const [loginFieldsErrs, setloginFieldsErrs] = useState({
    email: "",
    password: "",
   });
   const onInputChange = (field, value) => {
    setloginFields({
        ...loginFields,
        [field]: value,
      });
   
    };
   const handleSubmit = () => {

    // e.preventDefault();
   let formValidated =  validateService.login(setloginFieldsErrs,loginFields)
    if (formValidated) {
      setLoader(true)
      apiService.login(loginFields).then((res) => {
         console.log(res)
        //  return
         setLoader(false)
        localStorage.setItem("web_token",res.data.data.token)
        localStorage.setItem("user",res.data.data.user.id)
        localStorage.setItem("profile_status",res.data.data.user.status)
        localStorage.setItem("stripeCustomerId",res.data.data.user.stripeCustomerId)
        localStorage.setItem("stripeBankId",res.data.data.user.stripeBankId)
        
        if(res.data.data.user.imagePath){
          localStorage.setItem("profile_img",baseUrl+res.data.data.user.imagePath)
        }
      
        
         setloginFields({
                role:"cultivator",
                email: "",
                password: "",
            });
            setloginFieldsErrs({
                email: false,
                emailErr:"",
                password: false,
                passwordErr:"",
               
              });
              if(res.data.data.name != ""){
                 window.location.href = "/dashboard"
                // history("/dashboard");
              }else{
                CreateProfile()
              }
     }).catch((err) => {
          setLoader(false)
          console.log(err)
          swal("Error",err.response.data.message,"error")
         console.log("contact us api error", err.response);
        });
    }


  }
  return (
    <>
      <section className="login-section">
      {loader && <Loader/>}
        <Container>
          <Row>
            <Col lg={6} md={8}>
              <div className="login-form-box">
                <div className="login-header">
                  <h2>Sign In </h2>
                  <p>Use email address and password.</p>
                </div>
                <Form className="login-body">
                  <Form.Group className="mb-3">
                    <Form.Label>Email Address</Form.Label>
                    <Form.Control type="email" placeholder="Enter Email Address" onChange={(e)=>onInputChange("email", e.target.value)}/>
                    <span className="text-danger">{loginFieldsErrs.email}</span>
                  </Form.Group>
                  <Form.Group className="mb-3 position-relative">
                    <Form.Label>Password</Form.Label>
                    <Form.Control type={showPass?"text":"password"} placeholder="Enter Password"  onChange={(e)=>onInputChange("password", e.target.value)}/>
                    {showPass?
                    <img
                    className="eye-icon"
                    src={require("../assets/images/eye-crossed 1.svg").default}
                    onClick={()=>setshowPass(false)}
                    alt="img"
                  />:
                    <img
                      className="eye-icon"
                      onClick={()=>setshowPass(true)}
                      src={require("../assets/images/eye (1).svg").default}
                      alt="img"
                    />}
                    {/* <img
                  className="eye-icon"
                  src={require("../assets/images/eye-crossed 1.svg").default}
                  alt="img"
                /> */}
                    <span className="text-danger">{loginFieldsErrs.password}</span>
                  </Form.Group>
                  <Link to="/forgot-password" className="forgot-password-txt">Forgot password?</Link>
                  <Button onClick={handleSubmit} className="green-btn">Sign In</Button>
                  <p>Don’t have an account? <Link to="/signup" className="">Sign Up</Link></p>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};
export default Login;
